export const generateRandomArray = (): number[] => {
	const randomArray = [];

	for (let i = 0; i < 12; i++) {
		// Generate a random number between 0 and 1, then scale it to a desired range
		const randomNumber = Math.random() * 100; // Change 100 to set the desired range

		randomArray.push(randomNumber);
	}

	return randomArray;
};

export const options = {
	responsive: true,
	plugins: {
		legend: {
			position: "bottom" as const
		}
	}
};

export const labels = [
	"January",
	"February",
	"March",
	"April",
	"May",
	"June",
	"July",
	"August",
	"September",
	"October",
	"November",
	"December"
];
